import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { defineCustomElements as initFallbackOiamOauthComponent, setNonce as oiamSetNonce } from '@oiambk/oiam-oauth-wc';
import { defineCustomElements as initFallbackHeaderFooter, setNonce as headerFallbackSetNonce } from '@header-footer/bahf-header-footer-fallback/loader';
import { initI18Next } from './app/core/services/i18next-init.service';
import {loadWebComponent} from "./app/shared/web-components";
import {environment} from "./environments/environment";


void (async () => {
    const nonce = document.body.dataset['cspNonce'] || '';
    // Init Header / Footer Nonce
    headerFallbackSetNonce(nonce);
    oiamSetNonce(nonce);

    // Fallback-Komponenten initialisieren
    initFallbackHeaderFooter();
    initFallbackOiamOauthComponent();

    try {
        // i18next initialisieren
        await initI18Next();
        // header / footer / auth / feedback web components initialisieren
        loadWebComponent(environment.headerFooter.headerUrlEsm, nonce, true);
        loadWebComponent(environment.headerFooter.headerUrl, nonce);
        if (!environment.local) {
            loadWebComponent(environment.feedbackUrl + '/loader.js', nonce, false, true);
        }
        if (environment.oiam.enabled) {
            loadWebComponent(environment.oiam.oauthWcUrl + '/oiam-oauth-wc.esm.js', nonce, true);
            loadWebComponent(environment.oiam.oauthWcUrl + '/oiam-oauth-wc.js', nonce, false);
        }

        await bootstrapApplication(AppComponent, appConfig);
    } catch (e) {
        console.error(`Error initializing app`, e);
    }
})();



